import { render } from "./CoresFiltro.vue?vue&type=template&id=6a97ca36"
import script from "./CoresFiltro.vue?vue&type=script&lang=js"
export * from "./CoresFiltro.vue?vue&type=script&lang=js"

import "./CoresFiltro.vue?vue&type=style&index=0&id=6a97ca36&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__